export default function DNSRecordsTable({
  records,
}: {
  records: { type: string; name: string; value: string }[];
}) {
  return (
    <table className="mt-2.5 w-full">
      <thead>
        <tr className="text-left">
          <th>Type</th>
          <th>Name</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {records.map(({ type, name, value }) => (
          <tr className="" key={type}>
            <td className="">{type}</td>
            <td className="">{name}</td>
            <td className="">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
